"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstantiationServiceBuilder = void 0;
var service_collection_1 = require("./service-collection");
var instantiation_service_1 = require("./instantiation-service");
/**
* 为了解决构造函数中参数过多的问题，使用builder模式来构造
*/
var InstantiationServiceBuilder = /** @class */ (function () {
    function InstantiationServiceBuilder(services, strict, parent) {
        if (services === void 0) { services = new service_collection_1.ServiceCollection(); }
        if (strict === void 0) { strict = false; }
        this.instantiationService = new instantiation_service_1.InstantiationService(services, strict, parent);
    }
    InstantiationServiceBuilder.prototype.serviceRegister = function (serviceRegister) {
        var _this = this;
        serviceRegister
            .getServiceDescriptors()
            .forEach(function (_a) {
            var _b = __read(_a, 2), id = _b[0], descriptor = _b[1];
            return _this.instantiationService.addService(id, descriptor);
        });
        // 处理同一个ID绑定多个服务的情况
        serviceRegister
            .getMulServiceDescriptor()
            .forEach(function (_a) {
            var _b = __read(_a, 2), id = _b[0], descriptor = _b[1];
            return _this.instantiationService.addService(id, descriptor, true);
        });
        return this;
    };
    InstantiationServiceBuilder.prototype.build = function () {
        return this.instantiationService;
    };
    return InstantiationServiceBuilder;
}());
exports.InstantiationServiceBuilder = InstantiationServiceBuilder;
//# sourceMappingURL=instantiation-service-builder.js.map